/**
 * feature-config flag names owned by sp success
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const SP_SUCCESS_FLAG_NAMES = {
  AGENCY_AS_GUEST: 'ff-sps-3505-agency-guest',
  AGENCY_AS_GUEST_LEGACY_CONVERSION: 'ff-sps-3700-aag-legacy-conversion',
  APP_PAYMENTS_CREATOR: 'mrkpl-2313-app-payments-creator',
  APP_SEARCH_INDEX_UPDATES: 'ff-sps-4591-app-search-index-updates',
  AVAILABILITY_IN_PRODUCT: 'ff-sps-5580-availability-in-product',
  CERTIFIED_PARTNER_PROGRAM_SLACK_DEPRECATION:
    'ff-sps-5060-certified-partner-program-slack-deprecation',
  DISABLE_SUBDOMAIN_INDEXING_BY_DEFAULT: 'ff-sps-4238-disable-subindex-default',
  EXPANDED_PARTNER_PROGRAM: 'ff-sps-4821-expanded-partner-program',
  EXPANDED_PARTNER_PROGRAM_GA: 'ff-sps-4876-expanded-partner-program-ga',
  IS_AGENCY_OR_FREELANCER_UPDATE: 'ff-sps-4714-is-agency-or-freelancer-update',
  // Gates every partner email migrated from Zapier/Iterable to Knock.
  KNOCK_PARTNER_EMAILS: 'ff-lif-464-marketing-partner-knock-emails',
  LIB_INSTALL_NO_PROFILE_SLUG: 'ff-sps-4710-lib-install-no-profile-slug',
  MARKETPLACE_MIW_TEMPLATE_FINDER: 'ff-sps-miw-template-finder',
  MARKETPLACE_MIW_CAMPAIGN: 'ff-sps-miw-campaign-lane',
  MARKETPLACE_XLARGE_MIGRATION: 'ff-sps-5230-marketplace-xlarge-migration',
  MARKETPLACE_HUB_V2: 'ff-sps-marketplace-hub-v2',
  MRP_CLUSTER_MIGRATION: 'ff-sps-4617-mrp-cluster-migration',
  OIDC_PROVIDER: 'sps-3905-oidc-provider',
  PARTNER_COMMISSIONS_V2: 'sps-3352-partner-commissions-v2',
  PARTNER_HUB_COMMUNITY_EMBED: 'ff-sps-5474-partner-hub-community-embed',
  PARTNER_HUB_TRAINING_TAB: 'ff-sps-5261-partner-hub-training-tab',
  LOWERCASE_SITEPROFILE_SLUGS: 'sps-397-lowercase-siteprofile-slugs',
  PARTNER_SANDBOX_PROVISIONING: 'ff-sps-3821-partner-sandbox-provisioning',
  SITE_PROFILE_MIGRATION_DUAL_MUTATION:
    'ff-sps-4065-site-profile-mrp-dual-mutation',
  SITE_PROFILE_MIGRATION_DUAL_READ_COMPARE_ONLY:
    'ff-sps-4065-site-profile-mrp-dual-read-compare-only',
  SITE_PROFILE_MIGRATION_DUAL_READ_MRP_DATA:
    'ff-sps-4065-site-profile-mrp-dual-read-mrp-data',
  PARTNER_POINTS_PROMO: 'ff-sps-4731-partner-points-promo',
  PNP_42_PARTNER_PROGRAM_UPDATES: 'ff-sps-5071-pnp-4-2-partner-program-updates',
  OPTIMIZE_MAYBE_REPORT_REVENUE_FOR_INVOICE:
    'sps-4669-optimize-maybereportrevenueforinvoice',
  MARKETPLACE_AUTH_MIDDLEWARE_IMPROVEMENT:
    'ff-sps-4845-marketplace-auth-middleware-improvement',
  TEMPLATE_MIGRATION_DUAL_MUTATION: 'ff-sps-4856-template-mrp-dual-mutation',
  TEMPLATE_MIGRATION_DUAL_READ: 'ff-sps-4856-template-mrp-dual-read',
  WEBFLOW_NEXT: 'ff-sps-5251-webflow-next',
  WHITE_GLOVE_ACCELERATION: 'ff-lif-136-white-glove-acceleration',
  WHITE_GLOVE_PURCHASE_NOTIFY: 'ff-lif-135-white-glove-purchase-notify',
};

export const SP_SUCCESS_EXPERIMENT_NAMES = {
  MARKETPLACE_LOGGED_OUT_REDIRECT:
    'exp-sps-4670-marketplace-logged-out-redirect',
  PRIORITIZE_MIW_CLONEABLE_CONTENT: 'exp-sps-4833-prioritize-miw-cloneable',
  SHOW_TEMPLATES_ON_CERTAIN_MIW_TAG_PAGES:
    'exp-sps-4848-show-templates-on-certain-miw-tag-pages',
} as const;

export const SP_SUCCESS_EXPERIMENT_LAYERS = {
  MADE_IN_WEBFLOW_EXPERIMENTS: 'made-in-webflow-experiments',
} as const;

export const SP_SUCCESS_DYNAMIC_CONFIG_NAMES = {
  CERTIFIED_PARTNER_COMMUNITY_SPACE_IDS:
    'dc-sps-3177-certified-partner-community-space-ids',
  FOUNDATIONS_PARTNER_COMMUNITY_SPACE_IDS:
    'dc-sps-4876-foundations-partner-community-space-ids',
  PARTNER_PROGRAM_ONBOARDING_VIDEOS:
    'dc-sps-5037-partner-program-onboarding-videos',
  TEMPLATE_IDS_FOR_MIW: 'dc-sps-4848-template-ids-for-miw',
  WEBFLOW_INTERNAL_COMMUNITY_SPACE_IDS:
    'dc-sps-5334-webflow-internal-community-space-ids',
} as const;
